export enum DialogActionType {
    DeleteConfirmation = 'Delete',
    DiscardConfirmation = 'Discard',
    ClearConfirmation = 'Clear',
    SingleButtonConfirmation = 'OK',
    Warning = 'warning'
}
